import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {IDealCardEvent, IDealTimeline} from "../../models/i-deal-card";

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit, OnChanges {

  readonly PADDING_LEFT = 1.5;

  // @Input() desc: string = 'This is where the deal is';
  // @Input() percent: number = 75;
  @Input() dealTimeline!: IDealTimeline;
  // @Input() showTitles: boolean = false;

  circleHover: boolean[] = [];
  markerHover: boolean = false;

  constructor() {

  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes && changes['dealTimeline']) {
      this.dealTimeline = changes['dealTimeline'].currentValue;
    }
  }

  getMarkerStyles(t: IDealCardEvent) {
    return {
      'border-color': '#333',
      'background-color': this.getMarkerColor(t),
      'margin-left': t.xPos + "%"
    }
  }

  getMarkerColor(t: IDealCardEvent) {
    switch (t.status) {
      case 'CURRENT':
        return '#0044c1';
      case 'FUTURE':
        return '#E8E8E8';
      case 'PAST':
        return '#0044c1';
      default:
        return '#444444';
    }
  }
}
